import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import type { HarvestSyncPoint } from '@/hooks/useEntityHarvestVsSync';

/**
 * Dual-line chart: items harvested vs items synced per time bucket for one
 * entity. Bucket labels are pre-formatted for the active timeframe, so the axis
 * renders them as-is.
 */
export function HarvestSyncChart({ data }: { data: HarvestSyncPoint[] }) {
  if (!data.length) {
    return (
      <div className="flex h-56 items-center justify-center text-xs text-muted-foreground">
        No harvest or sync activity in window.
      </div>
    );
  }
  return (
    <div className="h-56 w-full">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data} margin={{ top: 8, right: 12, left: 0, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="hsl(222 18% 18%)" />
          <XAxis dataKey="bucket" tick={{ fill: 'hsl(215 14% 65%)', fontSize: 11 }} stroke="hsl(222 18% 18%)" />
          <YAxis tick={{ fill: 'hsl(215 14% 65%)', fontSize: 11 }} stroke="hsl(222 18% 18%)" allowDecimals={false} />
          <Tooltip
            contentStyle={{
              background: 'hsl(222 24% 9%)',
              border: '1px solid hsl(222 18% 18%)',
              borderRadius: 8,
              fontSize: 12,
            }}
          />
          <Legend wrapperStyle={{ fontSize: 12 }} />
          <Line
            type="monotone"
            dataKey="harvested"
            name="Harvested"
            stroke="hsl(199 89% 55%)"
            strokeWidth={2}
            dot={false}
          />
          <Line
            type="monotone"
            dataKey="synced"
            name="Synced"
            stroke="hsl(160 84% 45%)"
            strokeWidth={2}
            dot={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
